import React, { useState } from "react";
import { callAPI, useStore, useUser, usePage } from "../../Utils/utils";
import { vendor_page_labels } from "../../Constants/Labels";
import Layout from "../../Components/Global/Layout";
import AddBlockButton from "../../Components/HomePage/AddBlockButton/AddBlockButton";
import BannerBlock from "../../Components/HomePage/BannerBlock/BannerBlock";
import TextAndImageBlock from "../../Components/HomePage/TextAndImageBlock/TextAndImageBlock";
import ImageAndTextBlock from "../../Components/HomePage/ImageAndTextBlock/ImageAndTextBlock";
import TextAndVideoBlock from "../../Components/HomePage/TextAndVideoBlock/TextAndVideoBlock";
import VideoAndTextBlock from "../../Components/HomePage/VideoAndTextBlock/VideoAndTextBlock";
import ImageSelector from "../../Components/ImageSelector/ImageSelector";
import "./HomePage.css";

const HomePage = () => {
    const { user, setUser } = useUser();
    const { store, setStore } = useStore();
    const { page, setPage } = usePage();

    const [blocks, setBlocks] = useState([]);
    const [showBlockOptions, setShowBlockOptions] = useState(false);
    const [config, setConfig] = useState();
    const [bannerBlock, setBannerBlock] = useState();
    const [bannerBlockImage, setBannerBlockImage] = useState([]);
    const [showImageSelector, setShowImageSelector] = useState(false);

    const addBlock = (blockType) => {
        const newBlock = {
            id: Date.now(),
            type: blockType,
            data: getDefaultBlockData(blockType)
        };

        // Initialize block-specific data if it's a banner block
        if (blockType === 'banner') {
            newBlock.bannerBlock = {
                heading: '',
                sub_heading: '',
                description: '',
                button_label: '',
                button_url: '',
                img_button_url: ''
            };
            newBlock.bannerBlockImage = null;
        }

        // Initialize block-specific data if it's a text and image block
        if (blockType === 'textAndImage') {
            newBlock.textAndImageBlock = {
                heading: '',
                description: '',
                button_label: '',
                button_url: '',
                secondary_button_label: '',
                secondary_button_url: '',
                primary_button_label: '',
                primary_button_url: ''
            };
            newBlock.textAndImageBlockImage = null;
        }

        // Initialize block-specific data if it's an image and text block
        if (blockType === 'imageAndText') {
            newBlock.imageAndTextBlock = {
                heading: '',
                description: '',
                button_label: '',
                button_url: '',
                secondary_button_label: '',
                secondary_button_url: '',
                primary_button_label: '',
                primary_button_url: ''
            };
            newBlock.imageAndTextBlockImage = null;
        }

        if (blockType === 'textAndVideo') {
            newBlock.textAndVideoBlock = {
                heading: '',
                description: '',
                button_label: '',
                button_url: '',
                secondary_button_label: '',
                secondary_button_url: '',
                primary_button_label: '',
                primary_button_url: '',
                video_url: ''
            };
        }

        if (blockType === 'videoAndText') {
            newBlock.videoAndTextBlock = {
                heading: '',
                description: '',
                button_label: '',
                button_url: '',
                secondary_button_label: '',
                secondary_button_url: '',
                primary_button_label: '',
                primary_button_url: '',
                video_url: ''
            };
        }

        setBlocks([...blocks, newBlock]);
        setShowBlockOptions(false);
    };


    const getDefaultBlockData = (blockType) => {
        switch (blockType) {
            case 'banner':
                return {
                    title: 'Welcome Banner',
                    subtitle: 'Your subtitle here',
                    backgroundImage: '',
                    buttonText: 'Learn More',
                    buttonLink: '#'
                };
            case 'textAndImage':
                return {
                    title: 'Our Features',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    image: '',
                    imagePosition: 'left'
                };
            case 'imageAndText':
                return {
                    title: 'Why Choose Us',
                    text: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                    image: '',
                    imagePosition: 'right'
                };
            case 'textAndVideo':
                return {
                    title: 'Video Features',
                    text: 'Learn more through our video presentation.',
                    video_url: '',
                    videoPosition: 'right'
                };
            case 'videoAndText':
                return {
                    title: 'Video Overview',
                    text: 'A quick overview of what we do.',
                    video_url: '',
                    videoPosition: 'left'
                };
            default:
                return {};
        }
    };

    const removeBlock = (blockId) => {
        setBlocks(blocks.filter(block => block.id !== blockId));
    };

    const updateBlock = (blockId, newData) => {
        setBlocks(blocks.map(block =>
            block.id === blockId ? { ...block, data: { ...block.data, ...newData } } : block
        ));
    };

    // Banner block functions
    const onChangeBannerBlockField = (blockId, event) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, bannerBlock: { ...block.bannerBlock, [event.target.name]: event.target.value } }
                : block
        ));
    };

    const onChangeBannerBlockDescription = (blockId, value) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, bannerBlock: { ...block.bannerBlock, description: value } }
                : block
        ));
    };

    const onOpenBannerImageBlockSelector = (blockId, config) => {
        setConfig({ ...config, bannerBlockImage: true, currentBlockId: blockId });
        setShowImageSelector(true);
    };

    const onRemoveBannerBlockImage = (blockId) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, bannerBlockImage: null }
                : block
        ));
    };

    const onSelectImages = (images) => {
        if (config?.bannerBlockImage && config?.currentBlockId) {
            setBlocks(blocks.map(block =>
                block.id === config.currentBlockId
                    ? { ...block, bannerBlockImage: images }
                    : block
            ));
        }
        if (config?.textAndImageBlockImage && config?.currentBlockId) {
            setBlocks(blocks.map(block =>
                block.id === config.currentBlockId
                    ? { ...block, textAndImageBlockImage: images }
                    : block
            ));
        }
        if (config?.imageAndTextBlockImage && config?.currentBlockId) {
            setBlocks(blocks.map(block =>
                block.id === config.currentBlockId
                    ? { ...block, imageAndTextBlockImage: images }
                    : block
            ));
        }
        setShowImageSelector(false);
    };

    const onClose = () => {
        setShowImageSelector(false);
    };

    // Text and Image block functions
    const onChangeTextAndImageBlockField = (blockId, event) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, textAndImageBlock: { ...block.textAndImageBlock, [event.target.name]: event.target.value } }
                : block
        ));
    };

    const onChangeTextAndImageBlockDescription = (blockId, value) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, textAndImageBlock: { ...block.textAndImageBlock, description: value } }
                : block
        ));
    };

    const onOpenTextAndImageBlockImageSelector = (blockId, config) => {
        setConfig({ ...config, textAndImageBlockImage: true, currentBlockId: blockId });
        setShowImageSelector(true);
    };

    const onRemoveTextAndImageBlockImage = (blockId) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, textAndImageBlockImage: null }
                : block
        ));
    };

    // Image and Text block functions
    const onChangeImageAndTextBlockField = (blockId, event) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, imageAndTextBlock: { ...block.imageAndTextBlock, [event.target.name]: event.target.value } }
                : block
        ));
    };

    const onChangeImageAndTextBlockDescription = (blockId, value) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, imageAndTextBlock: { ...block.imageAndTextBlock, description: value } }
                : block
        ));
    };

    const onOpenImageAndTextBlockImageSelector = (blockId, config) => {
        setConfig({ ...config, imageAndTextBlockImage: true, currentBlockId: blockId });
        setShowImageSelector(true);
    };

    const onRemoveImageAndTextBlockImage = (blockId) => {
        setBlocks(blocks.map(block =>
            block.id === blockId
                ? { ...block, imageAndTextBlockImage: null }
                : block
        ));
    };

    // Text and Video block functions
    const onChangeTextAndVideoBlockField = (blockId, event) => {
        setBlocks(blocks.map(block => 
            block.id === blockId 
                ? { ...block, textAndVideoBlock: { ...block.textAndVideoBlock, [event.target.name]: event.target.value } }
                : block
        ));
    };

    const onChangeTextAndVideoBlockDescription = (blockId, value) => {
        setBlocks(blocks.map(block => 
            block.id === blockId 
                ? { ...block, textAndVideoBlock: { ...block.textAndVideoBlock, description: value } }
                : block
        ));
    };

    // Video and Text block functions
    const onChangeVideoAndTextBlockField = (blockId, event) => {
        setBlocks(blocks.map(block => 
            block.id === blockId 
                ? { ...block, videoAndTextBlock: { ...block.videoAndTextBlock, [event.target.name]: event.target.value } }
                : block
        ));
    };

    const onChangeVideoAndTextBlockDescription = (blockId, value) => {
        setBlocks(blocks.map(block => 
            block.id === blockId 
                ? { ...block, videoAndTextBlock: { ...block.videoAndTextBlock, description: value } }
                : block
        ));
    };

    const renderBlock = (block) => {
        switch (block.type) {
            case 'banner':
                return (
                    <BannerBlock
                        key={block.id}
                        data={block.data}
                        onUpdate={(newData) => updateBlock(block.id, newData)}
                        onRemove={() => removeBlock(block.id)}
                        bannerBlock={block.bannerBlock || {}}
                        bannerBlockImage={block.bannerBlockImage}
                        onChangeBannerBlockField={(event) => onChangeBannerBlockField(block.id, event)}
                        onChangeBannerBlockDescription={(value) => onChangeBannerBlockDescription(block.id, value)}
                        onOpenBannerImageBlockSelector={(config) => onOpenBannerImageBlockSelector(block.id, config)}
                        onRemoveBannerBlockImage={() => onRemoveBannerBlockImage(block.id)}
                        config={config}
                    />
                );
            case 'textAndImage':
                return (
                    <TextAndImageBlock
                        key={block.id}
                        data={block.data}
                        onUpdate={(newData) => updateBlock(block.id, newData)}
                        onRemove={() => removeBlock(block.id)}
                        textAndImageBlock={block.textAndImageBlock || {}}
                        textAndImageBlockImage={block.textAndImageBlockImage}
                        onChangeTextAndImageBlockField={(event) => onChangeTextAndImageBlockField(block.id, event)}
                        onChangeTextAndImageBlockDescription={(value) => onChangeTextAndImageBlockDescription(block.id, value)}
                        onOpenTextAndImageBlockImageSelector={(config) => onOpenTextAndImageBlockImageSelector(block.id, config)}
                        onRemoveTextAndImageBlockImage={() => onRemoveTextAndImageBlockImage(block.id)}
                        config={config}
                    />
                );
            case 'imageAndText':
                return (
                    <ImageAndTextBlock
                        key={block.id}
                        data={block.data}
                        onUpdate={(newData) => updateBlock(block.id, newData)}
                        onRemove={() => removeBlock(block.id)}
                        imageAndTextBlock={block.imageAndTextBlock || {}}
                        imageAndTextBlockImage={block.imageAndTextBlockImage}
                        onChangeImageAndTextBlockField={(event) => onChangeImageAndTextBlockField(block.id, event)}
                        onChangeImageAndTextBlockDescription={(value) => onChangeImageAndTextBlockDescription(block.id, value)}
                        onOpenImageAndTextBlockImageSelector={(config) => onOpenImageAndTextBlockImageSelector(block.id, config)}
                        onRemoveImageAndTextBlockImage={() => onRemoveImageAndTextBlockImage(block.id)}
                        config={config}
                    />
                );
            case 'textAndVideo':
                return (
                    <TextAndVideoBlock 
                        key={block.id}
                        data={block.data}
                        onUpdate={(newData) => updateBlock(block.id, newData)}
                        onRemove={() => removeBlock(block.id)}
                        textAndVideoBlock={block.textAndVideoBlock || {}}
                        onChangeTextAndVideoBlockField={(event) => onChangeTextAndVideoBlockField(block.id, event)}
                        onChangeTextAndVideoBlockDescription={(value) => onChangeTextAndVideoBlockDescription(block.id, value)}
                        config={config}
                    />
                );
            case 'videoAndText':
                return (
                    <VideoAndTextBlock 
                        key={block.id}
                        data={block.data}
                        onUpdate={(newData) => updateBlock(block.id, newData)}
                        onRemove={() => removeBlock(block.id)}
                        videoAndTextBlock={block.videoAndTextBlock || {}}
                        onChangeVideoAndTextBlockField={(event) => onChangeVideoAndTextBlockField(block.id, event)}
                        onChangeVideoAndTextBlockDescription={(value) => onChangeVideoAndTextBlockDescription(block.id, value)}
                        config={config}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Layout>
            <div className="home-page">
                {/* <div className="card card-default">
                    <div className="card-header card-header-border-bottom">
                        <h2>Home Page Builder</h2>
                    </div> */}
                <div className="card-body">
                    <div className="page-builder">
                        {/* Render existing blocks */}
                        {blocks.map(renderBlock)}
                        {/* Add Block Button */}
                        <AddBlockButton
                            onClick={() => setShowBlockOptions(!showBlockOptions)}
                            showOptions={showBlockOptions}
                            onBlockSelect={addBlock}
                        />
                    </div>
                </div>
                {/* </div> */}
            </div>
            {showImageSelector && (
                <ImageSelector
                    Config={config}
                    onClose={onClose}
                    onSelectImageInfo={onSelectImages}
                />
            )}
        </Layout>
    )
}

export default HomePage;
